export const steps = [
  {
    id: 3,
    title: "Check MI Insights",
  },
  {
    id: 4,
    title: "Setup market share goal",
  },
  {
    id: 5,
    title: "Optimize Content",
  },
  {
    id: 6,
    title: "Setup Ad Spend Goal + ACOS goal",
  },
  {
    id: 7,
    title: "Add new product",
  },
  {
    id: "?",
    title: "$17M Market Share",
  },
];
